import React, { Component } from 'react';
import { Field } from '../../components/form/Layout';
import has from 'lodash/has';
import get from 'lodash/get';
import { useForm } from 'react-final-form'
import {isEmpty} from "lodash";

function FieldContainer ({ name, children, ...others }) {

        const data = useForm();
        let field = data.getFieldState(name);

        return (
            <Field
                {...others}
                touched={field && field.touched}
                valid={field && isEmpty(field.error)}
            >
                {children}
            </Field>
        );

}

export default FieldContainer;
